export default {
  pageTitle: '設備',
  metaDescription: '切断、成形、溶接、重量物運搬機械など、大規模な製作プロジェクトを支えるTEFの製造設備をご紹介します。',
  hero: { title: '設備' },
  manufacturing: {
    heading: '製造設備',
    intro: 'TEFは最先端の技術を備えた高度な製造設備を運用し、生産における効率性と精度を確保しています。',
    table: {
      headers: {
        tools: '設備名',
        dsc: 'DSC',
        edv: 'EDV',
        vyg: 'VYG',
        quantity: '台数',
      },
      rows: {
        crane: 'クレーン',
        hydraulicPress: '油圧プレス機',
        ncPressBreak: 'NCプレスブレーキ機',
        rollsBending: 'ロール曲げ機',
        pipeBending: 'パイプ/形鋼曲げ機',
        weldingMachines: '溶接機',
        cuttingMachines: '切断機',
        machineTools: '工作機械',
        mobileGenset: '移動式発電機・移動式コンプレッサー',
        inspectionTools: '検査機器',
        forklift: 'フォークリフト、移動式クレーン、トラッククレーン',
      },
    },
    maxSize: {
      note: '製作品の最大サイズは、陸上輸送の制約により制限されます。',
      maxDiameterLabel: '最大直径',
      maxDiameterValue: '6メートル',
      maxLengthLabel: '最大長さ',
      maxLengthValue: '約30メートル',
      overLimitNote: '最大制限サイズを超える製品については、ご相談に応じます。',
    },
  },
};
